import React from 'react';
import PropTypes from 'prop-types';
import { trackLink } from '../../lib/analytics-helper';

const Prompt = (props) => {
  const {
    message, buttonText, buttonLink, fptiText, isNewTab, id,
  } = props;
  const clickAction = (link, isTarget) => {
    trackLink({ id: 'homePage', link: `${link}` });
    const target = isTarget ? '_blank' : '_self';
    window.open(buttonLink, target);
  };
  return (
    <div className="prompt" id={`prompt-${id}`}>
      <div className="prompt-items">
        <div className="message">{message}</div>
        <button className="prompt-button" aria-label={buttonText} onClick={() => clickAction(fptiText, isNewTab)}>{buttonText}</button>
      </div>
    </div>
  );
};

Prompt.propTypes = {
  id: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  buttonText: PropTypes.string.isRequired,
  buttonLink: PropTypes.string.isRequired,
  fptiText: PropTypes.string.isRequired,
  isNewTab: PropTypes.bool,
};
Prompt.defaultProps = {
  isNewTab: false,
};
export default Prompt;
